import * as React from 'react'
import { I18nService } from '../../../../services/utils/i18n.service'

interface Props {
  roundOnVatPrice: boolean
  onChange: (roundOnVatPrice: boolean) => void
}

const i18nScoped = new I18nService(require('./quotation-form-round-on-vat-price.component.yml'))

export default function QuotationFormRoundOnVatPriceComponent ({ roundOnVatPrice, onChange }: Props) {
  return <div>
    { [false, true].map(value => <div key={ value ? 'on' : 'off' } className="inputRadio u-mls" style={{ display: 'inline-block' }}>
      <input
        type="radio"
        checked={ roundOnVatPrice === value }
        id={ `quotation_round_on_vat_price_${ value ? 'on' : 'off' }` }
        onChange={ () => onChange(value) } />

      <label htmlFor={ `quotation_round_on_vat_price_${ value ? 'on' : 'off' }` }>
        { i18nScoped.t(`round_on_vat_price_${ value ? 'on' : 'off'}`) }
      </label>
    </div>) }
  </div>
}